import React, { useEffect, useState } from 'react';
import styles from './OperatingInflowReconciliation.module.scss';
import { fetchOperatingInflowReconData } from '../../../../../store/dashboard/reconciliation/reconciliationApiHelpers';
import { useParams } from 'react-router-dom';
import Header from './components/Header';
import Rows from './components/Rows';
import AIBadge from '../../Overview/components/AIBadge/AIBadge';
import { ShimmerText, ShimmerThumbnail } from 'react-shimmer-effects';
import Tooltip from '../../../../../common/_custom/Tooltip/Tooltip';
import AIGeneratedBadge from '../../../../../common/AIGeneratedBadge/AIGeneratedBadge';
import HeaderBodyBox from '../../../../../common/HeaderBodyBox/HeaderBodyBox';

function OperatingInflowReconciliation({ assesseeOrgId }) {
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState<any>(null);

    useEffect(() => {
        assesseeOrgId && fetchData();
    }, [assesseeOrgId]);

    const fetchData = () => {
        setLoading(true);
        fetchOperatingInflowReconData(
            {
                orgId: params.id,
                gstType: 'REVENUE',
            },
            {
                onSuccess: (data) => {
                    setTableData(data);
                    setLoading(false);
                },
                onError: () => {
                    setLoading(false);
                },
            },
        );
    };

    const Loader = () => {
        return (
            <div style={{ background: 'white', padding: '16px', marginTop: '16px' }}>
                <React.Fragment>
                    <ShimmerThumbnail height={250} rounded className={styles.ShimmerBody} />
                </React.Fragment>
            </div>
        );
    };

    const NoData = () => {
        return <div className={styles.Nodata}>No Data Available</div>;
    };

    const renderTable = () => {
        if (!loading && !!!tableData?.rows?.length) {
            return <NoData />;
        }
        if (loading) {
            return <Loader />;
        }
        return (
            <div className={styles.TableContainer}>
                <div className={styles.TableWrapper}>
                    <table className={styles.OperatingInflowTable}>
                        {!!tableData?.headers?.length && (
                            <thead className={styles.TableHead}>
                                <Header data={tableData?.headers} />
                            </thead>
                        )}
                        {!!tableData?.rows?.length && (
                            <tbody className={styles.TableBody}>
                                <Rows rows={tableData?.rows} headers={tableData?.headers} tableRef={null} assesseeOrgId={assesseeOrgId} />
                            </tbody>
                        )}
                    </table>
                </div>
                <div className={styles.Note}>
                    <b>*Note:</b> Reconciliation is done only for the months where both GST and Bank Statements are present.
                </div>
            </div>
        );
    };

    const headerLeft = (
        <div className={styles.Left}>
            Operating Inflow Reconciliation
            {!!tableData?.dateRange && (
                <>
                    {tableData?.dateRange?.length > 45 ? (
                        <Tooltip content={tableData?.dateRange} direction="bottom">
                            <div className={styles.Date}>({tableData?.dateRange?.substring(0, 45)}...)</div>
                        </Tooltip>
                    ) : (
                        <div className={styles.Date}>({tableData?.dateRange})</div>
                    )}
                </>
            )}
        </div>
    );

    const headerRight = <AIGeneratedBadge />;

    return (
        <div className={styles.OperatingInflowReconciliation}>
            <HeaderBodyBox title={headerLeft} headerRight={headerRight}>
                <div className={styles.TableContainerWrapper}>{renderTable()}</div>
            </HeaderBodyBox>
        </div>
    );
}

export default OperatingInflowReconciliation;
